"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NChangedGroupOfSites_1 = require("./NChangedGroupOfSites");
/**
 * @author Tomas Leity
 */


var NChangedGroupOfSitesDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedGroupOfSitesDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NChangedGroupOfSitesDTO(products) {
    var _this;

    _classCallCheck(this, NChangedGroupOfSitesDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedGroupOfSitesDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedGroupOfSitesDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedGroupOfSitesDTO(mat.products);
    }
  }]);

  return NChangedGroupOfSitesDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedGroupOfSitesDTO = NChangedGroupOfSitesDTO;

NChangedGroupOfSitesDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedGroupOfSitesDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NChangedGroupOfSites_1.NChangedGroupOfSites.schema, function (mat) {
      return NChangedGroupOfSites_1.NChangedGroupOfSites.fromDataDict(mat);
    }))
  };
}();